import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Router from './routes';
import ThemeProvider from './theme';
import { StyledChart } from './components/chart';
import ScrollToTop from './components/scroll-to-top';
import { PopupProvider } from './context/PopupContext';

/**
 * @returns Initialize App UI
 */
export default function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <ThemeProvider>
          <PopupProvider>
            <ScrollToTop />
            <StyledChart />
            <Router />
          </PopupProvider>
        </ThemeProvider>
      </BrowserRouter>
    </HelmetProvider>
  );
}
